import { render } from "./SharePreviewModal.vue?vue&type=template&id=4b2fae7d&scoped=true"
import script from "./SharePreviewModal.vue?vue&type=script&lang=js"
export * from "./SharePreviewModal.vue?vue&type=script&lang=js"

import "./SharePreviewModal.vue?vue&type=style&index=0&id=4b2fae7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2fae7d"]])

export default __exports__